<!-- 拼板款数 -->
<template>
  <BaseFormItem2
    class="pbnum"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseInputNumber2
      v-model="val"
      width="130px"
      placeholder="拼板款数"
      :step="1"
      :min="1"
      :precision="0"
      :isError="isError"
      @input="handleEmit"
      @change="handleChange"
    ></BaseInputNumber2>
    <span class="pbnum__tips">指文件内有多少款不同的板子</span>
    <!-- 示例 -->
    <PbnumExample slot="other"></PbnumExample>
  </BaseFormItem2>
</template>

<script>
import PbnumExample from '@@/views/pcb/components/pbnumExample'

import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: 1
    },
    exampleData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    PbnumExample
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('pbnum')
    },
  },
  watch: {
    value(newVal) {
      this.val = newVal
      this.isShowError(false)
    }
  },
  methods: {
    handleEmit() {
      this.$emit('input', this.val)
      this.isShowError(false)
    },
    handleChange() {
      this.$emit('change', this.val)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.pbnum {
  .pbnum__tips {
    margin-left: 20px;
    color: $--color-text-placeholder;
  }
}
</style>